export var fakeUnsuggestResponse = function (_a) {
    var params = _a.params;
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                errorDescription: 'Failed to unsuggest user',
                success: false,
            };
        }
    }
    return { success: true };
};
export var fakeResponse = function (url) { return function (_a) {
    var params = _a.params;
    switch (url) {
        case 'watch/unsuggest':
            return fakeUnsuggestResponse({ params: params });
        default:
            return null;
    }
}; };
//# sourceMappingURL=fakeResponse.js.map